"use client"

import Breadcrumbs from "@/app/components/Breadcrumbs"
import { useBreadcrumbContext } from "@/app/contexts/BreadcrumbContext"
import { usePathname } from "next/navigation"

export default function HeaderBreadcrumbs() {
  // Custom-set breadcrumbs, only used in the editor when updating the title.
  const { breadcrumb } = useBreadcrumbContext()
  const pathname = usePathname() || ""

  // Fetch post name from pathname if there's a postId specified after /post/[postId].
  // const postId = pathname.match(/\/dashboard\/metrics\/post\/(\w+)/)?.[1]

  // TODO: Fetch post name from pathname if there's a postId specified after /post/[postId].
  // We'll need to do this in a server-side fetch that gets de-duped.

  if (pathname?.startsWith("/editor") && breadcrumb) {
    return (
      <Breadcrumbs
        breadcrumbs={[{ name: "Dashboard", url: "/dashboard" }]}
        currentPage={breadcrumb}
      />
    )
  } else if (pathname.startsWith("/dashboard/metrics")) {
    return (
      <Breadcrumbs
        breadcrumbs={[{ name: "Dashboard", url: "/dashboard" }]}
        currentPage={"Metrics"}
      />
    )
  } else if (pathname.startsWith("/settings")) {
    // Don't display breadcrumbs on settings pages
    return null
  }
}
